/**
 * 图表统一语义色板（与 theme/palette.ts 同口径；2026-09-02「科技蓝青」定档，全站无紫色系）。
 * 全站 ECharts option 的 itemStyle.color 一律引用此处，禁止硬编码十六进制，
 * 保证 cockpit / report / SLA / AI 等图表的配色、语义一致。
 * 注意：ECharts 在 canvas 内渲染，不解析 CSS 变量 —— 本文件色值一律字面量。
 */
export const CHART_COLORS = {
  /** 主色（深海蓝）——呼叫量、主指标 */
  primary: '#2563eb',
  /** 成功（绿）——接通、AI 完成、解决 */
  success: '#10b981',
  /** 警告（琥珀）——转人工、无应答、小休 */
  warning: '#f59e0b',
  /** 危险（红）——失败、呼损、异常 */
  danger: '#ef4444',
  /** AI / 辅助（电光青；2026-09-02 配色定档，AI=青 vs 业务=蓝）——AI 会话、产能 */
  purple: '#06b6d4',
  /** 中性（灰蓝）——待处理、中性情感 */
  neutral: '#64748b',
  /** 次要（暗灰）——已跳过、弱化项 */
  muted: '#475569',
} as const;

/**
 * 面积渐变色（ECharts `areaStyle.color.colorStops` 的色值出口）：
 * 由色板 hex 派生 `rgba(r, g, b, alpha)`，顶部用 alpha、底部传 0 即「自上而下淡出」。
 * 入参 hex 取自本文件 CHART_COLORS 或 theme/palette.ts 的语义色，页面不再写 rgba 字面量。
 */
export function areaFade(color: string, alpha: number): string {
  const hex = color.replace('#', '');
  if (hex.length !== 6) return color;
  const n = parseInt(hex, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}

/** 多系列 / 饼图默认分类调色板（按序取色）。
 *  前 5 档与主题强相关，后 3 档由 `theme/applyTheme.ts` 按当前主题派生（AI 深档 / AI 浅档 / 中性），
 *  此处只给默认主题的首屏值——写死固定尾色会让"AI 键"与尾色在同图里撞成同一颜色。 */
export const CHART_PALETTE = [
  CHART_COLORS.primary,
  CHART_COLORS.success,
  CHART_COLORS.warning,
  CHART_COLORS.danger,
  CHART_COLORS.purple,
  '#22d3ee',
  '#0e7490',
  CHART_COLORS.neutral,
] as const;
